export type PlatformAdminSection = "ai" | "skills" | "users";

const AI_ADMIN_ROLES = ["platform_admin", "ai_skill_admin", "ai_skill_auditor"];

export function canAccessPlatformAdmin(platformRoles: string[]): boolean {
  return platformRoles.some((role) => AI_ADMIN_ROLES.includes(role));
}

export function platformAdminSectionIds(platformRoles: string[]): PlatformAdminSection[] {
  if (!canAccessPlatformAdmin(platformRoles)) return [];
  return platformRoles.includes("platform_admin") ? ["ai", "skills", "users"] : ["skills"];
}
